import CollapsibleCard from "../../../components/CollapsibleCard";
import { ScrollArea } from "../../../components/ui/scroll-area";
import { useSelector } from "react-redux";
import { XMarkIcon } from "@heroicons/react/24/solid";
import IconButton from "../../../components/IconButton";
import { PencilSquareIcon } from "@heroicons/react/24/outline";
import { useExtCustomColumns, PINNED_FIELDS } from "../../../contexts/extractions/ExtCustomColumnContext";

const SelectedColumnsList = ({ onRemove, onCustomColRemove, detachCustomColumn, editAction }) => {
  const { extractionViewOnly } = useSelector((state) => state.Extractions);
  const {
    editCustomColumn,
    filteredSelectedColumns,
    filteredCustomColumns,
    usedFieldsInSelectedCustomColumns,
  } = useExtCustomColumns();

  const hasNoColumns = filteredSelectedColumns?.length === 0 && filteredCustomColumns?.length === 0;

  return (
    <CollapsibleCard
      title="Selected Columns"
      className="flex-1 flex flex-col min-h-0"
    >
      <div className="flex-1 min-h-0 flex flex-col overflow-hidden">
        <ScrollArea className="h-[230px] py-2 px-4">
          {hasNoColumns ? (
            <p className="text-sm text-muted-foreground text-center py-8">
              No columns selected
            </p>
          ) : (
            <ol className="space-y-2">
              {filteredSelectedColumns.map((column, index) => (
                <li
                  key={column}
                  className="flex items-center justify-between text-sm gap-2"
                >
                  <span className="flex-1">
                    <span className="font-medium">{index + 1}.</span>{" "}
                    {column}
                  </span>

                  <IconButton
                    aria-label={`Remove ${column}`}
                    variant="action_default"
                    size="icon-sm"
                    className="p-1 mb-1"
                    Icon={XMarkIcon}
                    onClick={() => onRemove(column)}
                    disabled={
                      extractionViewOnly ||
                      PINNED_FIELDS.has(column) ||
                      usedFieldsInSelectedCustomColumns?.has(column)
                    }
                  />
                </li>
              ))}

              {filteredCustomColumns.map((column, index) => (
                <li
                  key={column.label}
                  className="flex items-center justify-between text-sm gap-2"
                >
                  <span className="flex-1">
                    <span className="font-medium">{filteredSelectedColumns.length + index + 1}.</span>{" "}
                    {column.label}
                  </span>

                  <IconButton
                    aria-label={`Edit ${column.label}`}
                    variant="action_default"
                    size="icon-sm"
                    className="p-1 mb-1"
                    Icon={PencilSquareIcon}
                    onClick={() => editCustomColumn(column.value)}
                    disabled={extractionViewOnly}
                  />
                  <IconButton
                    aria-label={`Remove ${column.label}`}
                    variant="action_default"
                    size="icon-sm"
                    className="p-1 mb-1"
                    Icon={XMarkIcon}
                    onClick={() => onCustomColRemove(column.value)}
                    disabled={extractionViewOnly}
                  />
                </li>
              ))}
            </ol>
          )}
        </ScrollArea>
      </div>
    </CollapsibleCard>
  );
};

export default SelectedColumnsList;